export const toggleStyle = theme => ({
  borderRadius: "3px",
  cursor: "pointer",
  padding: "0.4em 0.875em",
  color: theme.palette.background.textColor,
  fontSize: "14px",
  height: "35px",
  lineHeight: "1.75"
});
